export default __webpack_public_path__ + "static/about-us-ari-7619e340f87f063a1793ee70828cf1c8.webp";